module.exports = __webpack_public_path__ + "img/wownow_logo@2x.4b3a5d69.png";